<template>
  <PageLayout>
    <template v-slot:header>
      <div class="ui padded grid">
        <div class="row">
          <div class="eight wide column">
            <Breadcrumb>
              <div class="active section">
                Relatório de Listagem de Associados
              </div>
            </Breadcrumb>
          </div>
        </div>
      </div>
    </template>
    <template v-slot:main>
      <div ref="modal" class="ui large modal" style="top: 40px">
        <iframe
          ref="viewer"
          width="100%"
          style="height: calc(100vh - 100px)"
        ></iframe>
      </div>
      <form
        :class="['ui small', { error: anyError }, 'form']"
        v-autocomplete-off
      >
        <div class="ui padded grid">
          <div v-show="loading" class="ui active inverted dimmer">
            <div class="ui text loader">Carregando...</div>
          </div>
          <div class="row">
            <div class="ten wide column">
              <div class="field">
                <label for="cotract-by-collaborator-report-plans">
                  Contrato
                </label>
                <select
                  id="cotract-by-collaborator-report-plans"
                  class="ui fluid search dropdown"
                  v-model="form.contract"
                >
                  <option
                    v-for="(contract, index) in contracts"
                    :key="index"
                    :value="contract.id"
                  >
                    {{ contract.owner_name }} - {{ contract.id }}
                  </option>
                </select>
              </div>
              <div class="ui divider"></div>
              <div class="field">
                <button
                  @click="run"
                  type="button"
                  name="run"
                  class="ui submit blue button"
                >
                  <i class="play icon"></i>Gerar Relatório
                </button>
              </div>
            </div>
          </div>
          <!-- row -->
        </div>
        <!-- grid -->
      </form>
    </template>
  </PageLayout>
</template>

<script>
import Api from '@/resources/Api';
import Breadcrumb from '@/components/breadcrumb';
import PageLayout from '@/layouts/page_layout';
import ContractEnum from '@/enumerations/contract_enum';
import { mapGetters } from 'vuex';

export default {
  components: { Breadcrumb, PageLayout },

  data() {
    return {
      loading: false,
      loaded: false,
      errors: {},
      contracts: [],
      form: {
        contract: [],
      },
    };
  },

  computed: {
    anyError() {
      return !_.isEmpty(this.errors);
    },
  },

  mounted() {
    this.getData();

    $('.ui.dropdown').dropdown();
  },

  methods: {
    async getData() {
      this.loading = true;

      const contractQuery = {
        q: {
          type_eq: 'Contract::Corporate',
          s: ['id asc']
        }
      };

      try {
        const contractResponse = await Api.contracts.search(contractQuery);
        this.contracts = _.clone(contractResponse.data.contracts);
      } catch (e) {
        this.$toast.show('Erro ao carregar dados', 'error');
        throw e;
      } finally {
        this.loading = false;
      }
    },

    errorsTo(key) {
      const errors = _.isEmpty(this.errors[key]) ? [] : this.errors[key];
      return errors.join(', ');
    },

    run() {
      this.loading = true;
      let data = {
        report: 'associates',
        CONTRACT_ID: this.form.contract.toString()
      };

      Api.report(data)
        .then(response => {
          const blob = new Blob([response.data], { type: 'application/pdf' });
          $(this.$refs.viewer).attr('src', window.URL.createObjectURL(blob));
          $(this.$refs.modal).modal('show');
        })
        .catch(error => {
          this.showError = true;
          throw error;
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>
